import React, { Component } from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import Wrapper from "../../../../_hoc/Wrapper";
import * as userActions from "../../../../_actions/userActions";
import getProfilePicture from "../../../../_selectors/userSelectors/getProfilePicture";
import getDisplayName from "../../../../_selectors/userSelectors/getDisplayName";
import getMyLocationForProfile from "../../../../_selectors/userSelectors/getMyLocationForProfile";
import getMyProfileCompletePercent from "../../../../_selectors/userSelectors/getMyProfileCompletePercent";
import getMyGender from "../../../../_selectors/userSelectors/getMyGender";
import { confirmAlert } from "react-confirm-alert";
import ProfileComplete from "./ProfileComplete";
class ProfileInfoWithImage extends Component {
  onImageSelected = (accepted, rejected) => {
    const { upload } = this.props;
    upload({ image: accepted[0] });
  };
  onImageRemove = () => {
    const { isFemale, removeProfilePicture } = this.props;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>
              Having a profile picture increases your chances of finding soul
              mate
            </p>
            <button onClick={onClose}>No</button>
            <button
              onClick={() => {
                removeProfilePicture({ isFemale });
                onClose();
              }}
            >
              Yes, Remove!
            </button>
          </div>
        );
      }
    });
  };
  render() {
    const { profilePic, name, location, profileComplete } = this.props;
    return (
      <Wrapper>
        <Dropzone
          ref={node => {
            this.dropzoneRef = node;
          }}
          onDrop={this.onImageSelected}
          style={{ display: "none" }}
          accept="image/jpeg, image/png"
          multiple={false}
        />
        <div class="profile margin-bottom-0">
          <div class="profile-image">
            <img src={profilePic} />
            <div class="profile-badges">
              <a
                onClick={() => {
                  this.dropzoneRef.open();
                }}
                class="profile-badges-left"
                title="Upload a profile picture"
              >
                <i class="fa fa-camera-retro" />
              </a>
              <a
                href="#"
                class="profile-badges-right"
                onClick={this.onImageRemove}
                title="Remove profile picture"
              >
                <i class="fa fa-times" />
              </a>
            </div>
          </div>
          <div class="profile-info">
            <h4>{name}</h4>
            {location ? (
              <span>
                <i className="fa fa-map-marker" /> {location}
              </span>
            ) : null}
          </div>
          <ProfileComplete profileComplete={profileComplete} />
        </div>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  profilePic: getProfilePicture(state),
  name: getDisplayName(state),
  location: getMyLocationForProfile(state),
  profileComplete: getMyProfileCompletePercent(state),
  isFemale: getMyGender(state)
});
const mapDispatchToProps = dispatch => ({
  upload: payload => dispatch(userActions.uploadProfilePicture(payload)),
  removeProfilePicture: payload =>
    dispatch(userActions.removeProfilePicture(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileInfoWithImage);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInfoWithImage/index.js